import type { FaireProductEntity } from "../../entity_types/product";

export const p_ug483gztkn: FaireProductEntity = {
  token: "p_ug483gztkn",
  type: "product",
  name: "Teacher Of The Year Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/25bbb93e909b1bc511ecccd7aee1c88d7d13f4440096b33408e0a0a9872468d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/54616242267e1578354fb48c9eeab90fafb81aeb176b0b7aafa610dc19711cb9.jpeg",
    "https://cdn.faire.com/fastly/9cd92f14a7353d48d56566d2bccc52f4e5ba24a52d2a36394b0d0163975f491f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/be5da6813cae807ca7045b6e1aed5b73d0fe60c6bcc4a9a9cf5c17e83f2b7f0a.jpeg",
    "https://cdn.faire.com/fastly/137f76615704be27e11b973350fd160e5d1f104fc292c676343e3a46cac8bf58.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the teacher who’s practically a superhero—these socks are the best way to celebrate our favorite teachers. Plus, they're softer and last WAY longer than apples. 🍎😉\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:21.693Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
